import URL from './../../util/URL';
import request from './../../util/request';
import CodeCache from '../CodeCache';
import CodeUtil from '../CodeUtil';

export default class Code {
    constructor() {
        // promise数组 控制form获取code数据的时序
        this.promiseArray = [];
        this.promiseObject = {}; //标记某些promise，这些promise是应用程序控制开始、结束
    }

    /***
     *
     * 入参: codeBH
     * 出差: codeMap
     */
    *getSingleCode(codeBH) {
        if (!codeBH) {
            throw new Error('入参codeBH不能为空！');
        }

        //（1）不需要后台请求
        if (CodeCache.isCodeExist(codeBH)) {
            let result = CodeCache.getCode(codeBH);
            return result;
        }

        //（2）需要请求后台的情况
        let singleCodeResolve = null;
        let singleCodePromise = new Promise((resolve) => {
            singleCodeResolve = resolve;
        });
        this.promiseArray.push(singleCodePromise);

        const codeMapResult = yield getSingleCodeByRequest(codeBH);
        CodeCache.addCodeList(codeMapResult);
        //后台请求完毕，并且code已经存入缓存，完成promise
        singleCodeResolve();

        return codeMapResult;
    }

    /***
     * 入参
     *     codeInfoArray :[codeBH1,codeBH2]
     * 出参
     *     codeMapResult : {codeBH1:[],codeBH2:codeMap}
     */
    *getCodeList(codeInfoArray) {
        if (!codeInfoArray) {
            throw new Error('入参codeInfoArray不能为空！');
        }

        if (!codeInfoArray instanceof Array) {
            throw new Error('入参codeInfoArray必须为Array数组类型！');
        }

        //获取需要向后台请求的codeList
        let requestCodeList = [];
        for (let i = 0; i < codeInfoArray.length; i++) {
            let codeBH = codeInfoArray[i].toUpperCase();
            if (requestCodeList.indexOf(codeBH) === -1 && !CodeCache.isCodeExist(codeBH)) {
                requestCodeList.push(codeBH);
            }
        }

        //（1）不需要向后台请求codeList，前台codeCache中都存在
        if (!requestCodeList.length) {
            let codeMapResult = {};
            for (let j = 0; j < codeInfoArray.length; j++) {
                let codeBH = codeInfoArray[j].toUpperCase();
                let codeMap = CodeCache.getCode(codeBH);
                codeMapResult[codeBH] = codeMap;
            }
            return codeMapResult;
        }

        //（2）需要请求后台的情况
        let codeListResolve = null;
        let codeListPromise = new Promise((resolve) => {
            codeListResolve = resolve;
        });
        this.promiseArray.push(codeListPromise);

        const codeMapList = yield getCodeListByRequest(codeInfoArray);
        CodeCache.addCodeList(codeMapList);

        //后台请求完毕，并且code已经存入缓存，完成promise
        codeListResolve();

        return codeMapList;
    }

    *getCode(codeBH, prefix) {
        yield Promise.all(this.promiseArray);

        let codeMap = CodeCache.getCode(codeBH);
        if (!codeMap) {
            codeMap = [];
        }
        let codeMapResult = CodeUtil.fiterCodeMapByPrefix(codeMap, prefix);

        return codeMapResult;
    }

    *wait() {
        yield Promise.all(this.promiseArray);
    }

    completeOne(promiseKey) {
        let { promiseResolve } = this.promiseObject[promiseKey];
        promiseResolve();
    }

    startOne(promiseKey) {
        let promiseResolve = null;
        let promiseObj = new Promise((resolve) => {
            promiseResolve = resolve;
        });

        this.promiseObject[promiseKey] = {
            promiseObj,
            promiseResolve
        };

        this.promiseArray.push(promiseObj);
    }
}

function* getCodeListByRequest(codeInfoArray) {
    if (!codeInfoArray) {
        throw new Error('入参codeInfoArray不能为空！');
    }

    if (!codeInfoArray instanceof Array) {
        throw new Error('入参codeInfoArray必须为Array数组类型！');
    }

    let url = new URL('codeCache/getCodeList');
    url.addPara('codeList', JSON.stringify(codeInfoArray));
    const result = yield request(url, false);

    let codeMapResult = JSON.parse(result);

    return codeMapResult;
}

function* getSingleCodeByRequest(codeBH) {
    if (!codeBH) {
        throw new Error('入参codeBH不能为空！');
    }

    let url = new URL('codeCache/getCode');
    url.addPara('code', codeBH);
    const result = yield request(url, false);
    let codeMap = JSON.parse(result);
    return codeMap;
}
